<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Configurationkey">
          <a-input placeholder="Configurationkey" v-decorator="[ 'configKey', validatorRules.configKey]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="ConfigurationName">
          <a-input placeholder="ConfigurationName" v-decorator="[ 'configName', validatorRules.configName]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Comment">
          <a-input placeholder="Comment" v-decorator="[ 'configComment', validatorRules.configComment]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="ConfigurationType">
          <a-select v-model:value="configType"
            v-decorator="[ 'configType', validatorRules.configType]"
          >
            <a-select-option :key="0">Handwritten</a-select-option>
            <a-select-option :key="5">Handwritten(Numbers Only)</a-select-option>
            <a-select-option :key="10">Single Select</a-select-option>
            <a-select-option :key="20">Multiple Select</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          v-if="configType === 10 || configType === 20 "
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Type Expression">
          <span style="font-size:12px;color:red">e.g.:[{"n":"Option Name","v":"Option Value"},{"n":"Option Name2","v":"Option Value2"}]</span>
          <a-input placeholder="Type Expression" v-decorator="[ 'configTypeExpression', validatorRules.configTypeExpression]"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Batch No.(-1:All)">
          <a-input placeholder="Batch No." v-decorator="[ 'appSsid']"/>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Language">
          <a-select default-value="" style="width: 120px" v-decorator="[ 'languageMark']">
            <a-select-option value="-1">
              All
            </a-select-option>
            <a-select-option value="en">
              English
            </a-select-option>
            <a-select-option value="es">
              Spanish
            </a-select-option>
          </a-select>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addSysConfig, editSysConfig } from '@/webpublicapi/importPayoutOrder';
// duplicateCheck
export default {
  name: 'sysConfigModal',

  data () {
    return {
      value: 1,
      title: 'Action',
      configType: 0,
      allowPrepay:1,
      visibleCheck: true,
      visible: false,
      model: {},
      appList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        configKey: { rules: [{ required: true, message: 'Please enterConfiguration key' }] },
        configName: { rules: [{ required: true, message: 'Please enterConfiguration Name' }] },
        configType: { rules: [{ required: true, message: 'Please selectType' }] },
        configTypeExpression: { rules: [{ required: true, message: 'Please enter required expression' }] },
        configComment: { rules: [{ required: true, message: 'Please enter config comment' }] }
      }

    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({languageMark: '-1', appSsid: '-1'})
    },
    edit (record) {

      this.form.resetFields()
      this.model = Object.assign({}, record)
      if (record.id) {
        this.allowPrepay = record.allowPrepay
        this.visibleCheck = (record.allowPrepay == 1)
        this.configType = record.configType;
      }
      this.visible = true;
      const data = pick(this.model, 'configKey', 'configName', 'configType', 'configComment', 'configTypeExpression', 'appSsid', 'languageMark');
      data.allowPrepay = !!data.allowPrepay;
      this.$nextTick(() => {
        this.form.setFieldsValue(data);
      })
    },
    onChose (checked) {
      if (checked) {
        this.allowPrepay = 1
        this.visibleCheck = true
      } else {
        this.allowPrepay = 0
        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk () {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          formData.allowPrepay = +formData.allowPrepay ? 1 : 0;
          let obj
          if (!that.model.id) {
            formData.id = null;
            obj = addSysConfig(formData)
          } else {
             obj = editSysConfig(formData)
          }
          obj.then((res) => {
            if (res.code === 1000) {
              that.$message.success(res.msg)
              that.$emit('ok');
              that.close();
            } else {
              that.$message.warning(res.msg)
            }
          }).finally(() => {
            that.confirmLoading = false
          })
        }
      })
    },
    // Close
    handleCancel () {
      this.close()
    },
    close () {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
